import "./index.scss";

import React, { ReactElement, useEffect, useState } from "react";
import FirstLoginModal from "./components/FirstLoginModal";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import cookie from "react-cookies";
import { lookReadAgreement, handleLocHref } from "../../utils/index.js";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { setUserInfo, setLoginStatus } from "@/features/user/userSlice";
import { decMsg, getPk } from "@/utils/kyberSm2";
import { encryUserInfo } from "../../api/login/index.js";
import WXScan from './components/WXScan';
import { Tabs } from "antd";
import CodeLogin from "./components/CodeLogin/index";
import PwdLogin from "./components/PwdLogin/index";
import type { ParamsType } from "./types";
import wxIcon from "./assets/wx.png";
import headerBanner from "./assets/header-banner.png";
import LoginHeader from '@/components/loginHeader/index';
import { getRequestParams } from "@/utils/index";
const titleBg =
  "https://qcloud-ftp.originqc.com/test/qcloud/background/login_title1.png";

const tips: Record<string, string> = {
  "1": "未注册用户扫码后自动登录，注册即代表同意 ",
  "2": "未注册手机号在验证通过后将自动完成注册，注册即表示您同意",
};

const Login: React.FC = (props: any): ReactElement => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { language } = useAppSelector((state) => state.common);
  const LANGUAGE = language === "en";
  // tabs 哪个激活
  const [activeKey, setActiveKey] = useState("2");
  // 控制页面跳转
  const [toControl, setToControl] = useState<boolean>(false);
  // 首次登录弹窗控制
  const [showFirstLoginModal, setShowFirstLoginModal] = useState<boolean>(false);
  // 用户信息缓存（用于首次登录判断）
  const [userInfoCache, setUserInfoCache] = useState<any>(null);
  useEffect(() => {
    const inkBar = document.querySelector(".ant-tabs-ink-bar") as Element;
    // 添加 first-active 类
    if (inkBar && activeKey === "2") {
      inkBar.classList.add("first-active");
    }
  }, []);
  // tabs 切换
  const tabsChangeFun = (key: string) => {
    // tabs 样式修改
    key === "3"
      ? (() => {
        const inkBar = document.querySelector(".ant-tabs-ink-bar") as Element;
        // 移除 second-active 类
        inkBar.classList.remove("first-active");
        // 添加 first-active 类
        inkBar.classList.add("second-active");
      })()
      : (() => {
        const inkBar = document.querySelector(".ant-tabs-ink-bar") as Element;
        // 移除 second-active 类
        inkBar.classList.remove("second-active");
        // 添加 first-active 类
        inkBar.classList.add("first-active");
      })();

    setActiveKey(key);
  };

  // 登录成功
  const loginSuccess = async (userinfo: ParamsType): Promise<void> => {
    const { cipher1, cipher2, salt } = await getPk(true);
    const useRes = await encryUserInfo({ cipher1, cipher2, salt });
    const userData = useRes?.data;
    if (userData?.success) {
      const useinfoRes = await decMsg(userData?.obj?.user ?? "", salt);
      dispatch(setUserInfo(JSON.parse(useinfoRes ?? "")));
      dispatch(setLoginStatus(true));
    }
    // cookie.remove('originqsid', { path: '/' });
    setToControl(true);
    // 判断是否在测试环境或者是线上环境
    // https://qcloud.originqc.com.cn
    // http://qcloud4test.originqc.com/测试环境
    // if (window.location.href.includes('.originqc.com')) {
    //   if (window.location.href.includes('.originqc.com.cn')) {
    //     // 线上环境
    //     cookie.save('originqsid', userinfo.originqsid, {
    //       path: '/',
    //       domain: '.originqc.com.cn',
    //     });
    //   } else {
    //     // 测试环境
    //     cookie.save('originqsid', userinfo.originqsid, {
    //       path: '/',
    //       domain: '.originqc.com',
    //     });
    //   }
    // } else {
    //   // 本地环境
    //   cookie.save('originqsid', userinfo.originqsid, { path: '/' });
    // }
  };

  useEffect(() => {
    // 监听是否登录成功，然后页面跳转
    if (toControl) {
      const hrefLocation = window.location.href;
      const forwardIndex = hrefLocation.indexOf("?forward=");
      if (forwardIndex > 0) {
        const hrefUrl = hrefLocation.substring(forwardIndex + 9);
        window.location.href = hrefUrl;
        return;
      }
      let toPath = `/${language}`;
      const params = new URLSearchParams(location.search);
      if (params.get("path")) {
        toPath = params.get("path") || "";
      }
      navigate({ pathname: toPath });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toControl]);

  // 首次登录弹窗关闭后的处理
  // 跳过绑定，继续执行登录成功后的逻辑
  const handleFirstLoginModalClose = () => {
    setShowFirstLoginModal(false);
      // 绑定成功，直接跳转
      setToControl(true);
      if (!location.search) {
        window.open(handleLocHref('') + language, "_self");
      }
  };

  // 验证码登录首次登录处理
  const handleCodeLoginFirstLogin = () => {
    setShowFirstLoginModal(true);
  };


  // 1 服务条款 2 隐私政策
  const handleReadAgreement = (type: number) => {
    lookReadAgreement(type);
  };

  const handleShowWX = () => {
    // navigate(`/${language}/l/wxLogin`)
    const hrefUrl = getRequestParams("forward");
    if (hrefUrl) {
      navigate(`/${language}/l/wxLogin${location.search}`);
    } else {
      navigate(`/${language}/l/wxLogin`);
    }
  };

  return (
    <div className="login-box">
      <LoginHeader flag={0} />
      {LANGUAGE ? (
        <div className="login-box-content-en">
          <div className="login-box-content-box">
            <div className={`form-box ${language}`}>
              <div className="login-en-title">Sign in</div>
              <PwdLogin loginSuccess={loginSuccess} />
            </div>
          </div>
        </div>
      ) : (
        <div className="login-box-content">
          <WXScan type={1} loginSuccess={loginSuccess} />
          <i className='line'></i>
          <div className="login-box-content-box">
            <div className={`form-box ${language}`}>
              <Tabs
                destroyInactiveTabPane={true}
                defaultActiveKey={activeKey}
                onChange={tabsChangeFun}
                items={[
                  {
                    label: "手机号登录",
                    key: "2",
                    children: <CodeLogin loginSuccess={loginSuccess} onFirstLogin={handleCodeLoginFirstLogin} />,
                  },
                  {
                    label: "账号密码登录",
                    key: "3",
                    children: <PwdLogin loginSuccess={loginSuccess} />,
                  },
                ]}
              ></Tabs>
              {activeKey !== "3" && (
                <div className="form-box-bottom-text">
                  <p>
                    {tips[activeKey]}
                    <span onClick={() => handleReadAgreement(1)}>
                      《服务条款》
                    </span>
                    &nbsp;和
                    <span onClick={() => handleReadAgreement(2)}>
                      《隐私协议》
                    </span>。
                    您也可使用<span className='light' onClick={() => navigate(`/${language}/l/register?tab=email`)}>邮箱注册</span>
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* 首次登录弹窗 */}
      <FirstLoginModal
        visible={showFirstLoginModal}
        onClose={handleFirstLoginModalClose}
        type='login'
      />
    </div>
  );
};

export default Login;
